import Layout from 'Layout'
import React, { useCallback, useEffect, useState } from 'react'
import CardNews from 'components/CardNews';
import { useNavigate, useParams } from 'react-router-dom';
import { getBeritaById, getBeritaByKategori } from 'services/apiRoutes';
import SkeletonArticle from 'skeletons/SkeletonArticle';


export default function PostBerita() {
  const navigate = useNavigate();
  const {slug,id} = useParams();
  
  const [berita, setBerita] = useState();
  const [idKategori,setIdKategori]= useState();
  const [beritaTerkait,setBeritaTerkait]=useState();

    const beritaAPI = useCallback(async (id) => {
      const res = await getBeritaById(id,slug);
      if (res.error) {
        return res.message;
      } else {
        const { data } = res.data;
        setIdKategori(data.list_kategori_berita_obj[0]?.kategori_obj.uuid);
        setBerita(data);
      }
    }, [slug]);

    const beritaTerkaitAPI = useCallback(async (limit,offset,id) => {
      const res = await getBeritaByKategori(limit,offset,id,slug)
      if (res.error) {
        return res.message;
      }else{
        const {data} = res.data;
        setBeritaTerkait(data);
      }
    },[slug])

    useEffect(() => {
      beritaAPI(id);
      beritaTerkaitAPI(2, 0, idKategori);
    }, [beritaAPI, id, idKategori, beritaTerkaitAPI]);
  return (
    <Layout>
      <div className="items-center px-5 xl:pt-44 pt-28 Pencapaian-wrapper xl:px-99">
        <h1 className="mb-20 text-2xl font-bold xl:text-7xl">
          {berita?.judul}
        </h1>
        <div className="postImage rounded-2xl xl:mb-[100px] shadow-lg mb-20">
          <img
            crossOrigin="anonymous"
            src={berita?.url_gambar}
            alt="gambar berita"
            className="w-full rounded-2xl md:h-[600px]"
          />
        </div>
        <div className="wrapperPost xl:flex xl:space-x-12">
          <div className="p-5 leading-6 border xl:p-10 rounded-2xl border-borderCardFeatures mb-28 xl:w-[70%]">
            {berita ? (
              <div dangerouslySetInnerHTML={{ __html: berita?.isi }} />
            ) : (
              <SkeletonArticle />
            )}
            {/* <p className="text-justify text-articleTitle">{berita?.isi}</p> */}

            {berita?.fileUrl && (
              <div className="mt-8">
                <h3 className="text-xl font-bold text-gray-900 mb-4">Lampiran PDF</h3>
                <div className="w-full h-[600px] rounded-2xl overflow-hidden border border-gray-200">
                  <iframe 
                    src={berita.fileUrl} 
                    title="Lampiran Dokumen PDF" 
                    className="w-full h-full"
                  />
                </div>
                <div className="mt-4">
                  <a 
                    href={berita.fileUrl} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-lg shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none"
                  >
                    Buka PDF di Tab Baru
                  </a>
                </div>
              </div>
            )}
          </div>
          {/* <div className="p-5 leading-6 border xl:p-10 rounded-2xl border-borderCardFeatures mb-28 xl:w-[70%]">
            <p className="text-justify text-articleTitle">
              Pada zaman dahulu kala, nama Gampong Geulanggang Teungoh merupakan
              gampongnya areal perternakan yang sangat dikenal dikalangan
              masyarakat Bireuen. Menurut cerita tokoh-tokoh masyarakat Bireuen,
              nama gampong tersebut bermula dari pengembalaan binatang ternak
              yang sangat banyak yang dilakukan masyarakat Bireuen. Gampong
              tersebut menjadi{" "}
              <span className="font-semibold text-spanBolder">
                ”Arena (Gelanggang)”
              </span>{" "}
              tempat hewan-hewan ternak yang dilepaskan bebas saling beradu. Di
              samping itu juga ada suatu lokasi yang dahulu dikenal dengan{" "}
              <span className="font-semibold text-spanBolder">
                ”Uteuen Rambong (Hutan atau Kebun Karet)”
              </span>{" "}
              yang sering dikunjungi masyarakat Bireuen pada sore dan malam hari
              untuk menonton berbagai macam acara kesenian budaya rakyat Aceh
              yang ditampilkan dilokasi tersebut.
            </p>
            <p className="text-justify text-articleTitle">
              Dicetuskanlah nama{" "}
              <span className="font-semibold text-spanBolder">
                Gampong Geulanggang Teungoh
              </span>{" "}
              yang disebabkan berada ”ditengah” yang diapit oleh Gampong lain
              yang sebelah Utara berbatasan dengan Gampong Geulanggang Kulam dan
              sebelah selatan dengan Gampong Geulanggang Gampong. Sekarang
              Sebelah Timur berbatas dengan Gampong Geulanggang Baro yang
              merupakan gampong pemekaran sejak tahun 2005 yang sebelumnya
              wilayahnya Dusun Baru Gampong Geulanggang Teungoh. Gampong
              Geulanggang Teungoh yang memiliki wilayahnya seluas 248 Ha berdiri
              sekitar pada tahun 1920. Gampong Geulanggang Teungoh yang terdiri
              dari 4 dusun, antara lain: Dusun Timur, Dusun Teungoh, Dusun Barat
              dan Dusun Lagang.
            </p>
          </div> */}
          <div className="wrapperCardNews xl:w-[30%] space-y-5 mb-20">
            <h1 className="text-base font-bold md:text-3xl ">Terkait</h1>
            {beritaTerkait
              ? beritaTerkait.map((item, index) =>
                  item.uuid === id
                    ? null
                    : index <= 1 && (
                        <CardNews
                          gallery
                          similar
                          onClick={() =>
                            navigate(`/${slug}/postberita/${item.uuid}`)
                          }
                          key={index}
                          img={item?.url_gambar}
                          label={
                            item?.list_kategori_berita_obj[index]?.kategori_obj
                              ?.nama
                          }
                          title={item?.judul}
                        />
                      )
                )
              : null}
          </div>
        </div>
      </div>
    </Layout>
  );
}
